export default __webpack_public_path__ + "static/media/36.8ca21549.png";